import { useState } from "react";
import { loaderContext } from "../context";

const PageLoaderProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(false);

  const showLoader = () => {
    setLoading(true);
  };

  const hideLoader = () => {
    setLoading(false);
  };

  return (
    <loaderContext.Provider value={{ isLoading, showLoader, hideLoader }}>
      {children}
      {isLoading && (
        <div className="backdrop">
          <div className="page-wrapper">
            <div className="pos-absolute-center">
              <div className="text-center">
                <span class="loader"></span>
              </div>
            </div>
          </div>
        </div>
      )}
    </loaderContext.Provider>
  );
};

export default PageLoaderProvider;
